<template>
  <div id="tool-box">
    <el-row :gutter="20" style="margin:0;">
      <el-col :span="4" v-for="(value,key) in componentsArr" :key="'comp_'+key">
        <component :is="value[0]" :ref="value[1]" @change="handleChange" @click="handleClick" @message="handleMessage" v-on="$listeners" :clear='clear'></component>
      </el-col>
      <el-col :span="3" ><el-button style="width: 100%" type="primary" v-if="componentsArr.length>0" @click="search">搜索</el-button></el-col>
      <el-col :span="3" v-if="showBack"><el-button style="width: 100%"  @click="back">返回</el-button></el-col>
      <el-col :span="3" v-if="showAdd" ><el-button style="width: 100%" type="primary" @click="handleAdd">添加</el-button></el-col>
    </el-row>
  </div>
</template>

<script>
    const components_links = require("./package.json")

    export default {
        props: {
            config: {
                type: Array,
                default: () => []
            },
            showAdd: {
                type: Boolean,
                default: true
            },
            showBack: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                componentsArr: [],
                data: {},
                clear: false
            }
        },
        mounted() {
            // 暂时禁用动态导入搜索组件，避免TypeScript编译错误
            // this.config.forEach((value, key) => {
            //     if (components_links[value]) {
            //         let comp = () => import(`${components_links[value]}`)
            //         let ref = `${value}Ref`
            //         this.componentsArr.push([comp, ref])
            //         this.data[ref] = {}
            //     }
            // })
        },
        methods: {
            handleAdd() {
                console.log(1)
                this.$emit('openAdd')
            },
            search() {
                this.$emit('handleSearch')
            },
            back() {
                this.clear = true
                this.$emit('backAll')
            },
            handleChange(e) {

            },
            handleClick(e) {

            },
            handleMessage(e) {

            }
        }
    }
</script>

<style scoped lang="scss">
  #tool-box{
    width: 100%;
  }
  .el-row {

    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
